<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";
import CategoryCard from "@/Components/Category/CategoryCard.vue";

const props = defineProps({
  category: {
    type: Object,
    required: true
  }
})

const emit = defineEmits(['remove'])

const removeCategory = () => {
  emit('remove', props.category.id)
}

</script>

<template>
  <div class="relative rounded-xl">
    <div class="absolute -top-4 z-30 -left-4">
      <button
        @click.prevent="removeCategory"
        type="button"
        class="h-8 w-8 p-1.5 bg-white hover:bg-gray-200 rounded-lg border border-gray-100"
      >
        <XMarkIcon class="w-full h-full bg-transparent text-red-400" />
      </button>
    </div>
    <CategoryCard :item="category" />
    <div
      class="absolute overflow-hidden rounded-2xl inset-0 bg-gray-50/20"></div>
    <div class="absolute rounded-2xl overflow-hidden inset-0 flex items-center justify-center">
      <div class="text-center text-white bg-black bg-opacity-50 rounded-full text-sm px-2 py-1">
        {{ __('Preview') }}
      </div>
    </div>
  </div>
</template>

